import {useCallback} from 'react';
import useDiToggleTags from './useDiToggleTags';
import {apiAddDataItemTag, apiRemoveDataItemTag} from '../../utils/api/tags';

/**
 * Item-level tags for one data item (Highlights search cards — bookmark rows are DataItems)
 * — toggle model on data_item_tag_link. Disabled (no-op) when dataItemId is null.
 */
export default function useDataItemTags({dataItemId, initialTags}) {
    const addFn = useCallback(
        ({name, userId}) => apiAddDataItemTag({dataItemId, name, userId}),
        [dataItemId]);
    const removeFn = useCallback(
        ({name, userId}) => apiRemoveDataItemTag({dataItemId, name, userId}),
        [dataItemId]);

    return useDiToggleTags({
        enabled: dataItemId != null,
        initialTags,
        addFn,
        removeFn,
    });
}
